export const timestampToFormattedDate = (timestampStr, showHour) => {
    const timestamp = parseInt(timestampStr) * 1000;
    const date = new Date(timestamp);
    return showHour ? date.toLocaleString() : date.toLocaleDateString();
};

export const dateToFormattedStr = (date) => {
    return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
};

export const datesAreTheSameDay = (date1, date2) => {
    return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
    );
};

export const getDaysBetweenTwoDates = (date1, date2) => {
    return Math.floor((date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24));
};

export const isDateInPeriod = (date, startDate, endDate) => {
    date.setHours(0, 0, 0, 0);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    return date.getTime() >= startDate.getTime() && date.getTime() <= endDate.getTime();
};
